import React from 'react'
import clsx from 'clsx'

const Panel = ({ className, children, tight = false }) => (
  <div className={clsx('rounded-3xl bg-white border border-slate-200 shadow-soft', className)}>
    <div className={clsx(tight ? 'p-4 md:p-5' : 'p-6 md:p-8')}>{children}</div>
  </div>
)

export default Panel
